'use client';
import { useContext } from 'react';
import {
  InstalledExtensionsContext,
  InstalledExtensionsContextValue,
} from '../context/installed-extensions-context';

// -----------------------------------------------------------------------------
// Consumer of the central InstalledExtensionsProvider. All the fetching lives in
// the provider (mounted once at the root), so this is just a shared-state read —
// no per-component network/bridge calls.
export const useInstalledExtensions = (): InstalledExtensionsContextValue => {
  return useContext(InstalledExtensionsContext);
};
